(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pickens-x-seam"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  if (customElements.get('pickens-xseam')) return;

  class PickensXseam extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;

      this._form = this.querySelector('[data-xseam-form]');
      this._input = this.querySelector('[data-xseam-input]');
      this._unit = this.querySelector('[data-xseam-unit]');
      this._result = this.querySelector('[data-xseam-result]');
      this._error = this.querySelector('[data-xseam-error]');
      this._cards = Array.from(this.querySelectorAll('[data-size-card]'));
      if (!this._form || !this._input || !this._unit || !this._result || !this._error) return;

      this._connected = true;
      this._previousUnit = this._unit.value;
      this._form.noValidate = true;
      this._clear();

      this._input.addEventListener('input', () => this._clear());
      this._unit.addEventListener('change', () => {
        const value = this._number();
        const nextUnit = this._unit.value;
        if (value !== null && nextUnit !== this._previousUnit) {
          const converted = nextUnit === 'cm' ? value * 2.54 : value / 2.54;
          if (Number.isFinite(converted)) {
            this._input.value = String(Math.round(converted * 1000) / 1000);
          }
        }
        this._previousUnit = nextUnit;
        this._input.placeholder = nextUnit === 'cm' ? 'e.g. 106.68' : 'e.g. 42';
        this._clear();
      });
      this._form.addEventListener('submit', (event) => {
        event.preventDefault();
        this._check();
      });
    }

    _number() {
      const raw = this._input.value.trim();
      if (!/^(?:\d+(?:[.,]\d*)?|[.,]\d+)$/.test(raw)) return null;
      const value = Number(raw.replace(',', '.'));
      return Number.isFinite(value) && value > 0 ? value : null;
    }

    _clear() {
      this._error.textContent = '';
      this._error.hidden = true;
      this._input.removeAttribute('aria-invalid');
      this._result.replaceChildren();
      this._result.removeAttribute('data-result-state');
      this._cards.forEach((card) => {
        card.dataset.match = 'false';
        const badge = card.querySelector('[data-match-badge]');
        if (badge) badge.hidden = true;
      });
    }

    _check() {
      this._clear();
      const value = this._number();
      if (value === null) {
        this._error.textContent = 'Enter a measurement greater than zero, using numbers and an optional decimal point or comma.';
        this._error.hidden = false;
        this._input.setAttribute('aria-invalid', 'true');
        this._input.focus();
        return;
      }

      const inches = this._unit.value === 'cm' ? value / 2.54 : value;
      const epsilon = 1e-9;
      const small = inches >= 33 - epsilon && inches <= 40 + epsilon;
      const standard = inches >= 39.5 - epsilon && inches <= 48 + epsilon;
      let state;
      let heading;
      let body;

      if (small && standard) {
        state = 'overlap';
        heading = 'Both ranges include your measurement.';
        body = 'Your X-seam falls in the overlap between Small and Standard. We can help you compare the options and confirm your riding position before you choose.';
      } else if (small) {
        state = 'small';
        heading = 'Your measurement is within the Small range.';
        body = 'Small is a starting point for your fit conversation. If your measurement is close to either end of the range, let us confirm pedal reach and riding position with you.';
      } else if (standard) {
        state = 'standard';
        heading = 'Your measurement is within the Standard range.';
        body = 'Standard is a starting point for your fit conversation. If your measurement is close to either end of the range, let us confirm pedal reach and riding position with you.';
      } else {
        state = 'outside';
        heading = 'Let’s confirm your fit together.';
        body = 'Your measurement is outside the published Small and Standard ranges. Check your measurement using the guide above, then contact us to discuss fit before choosing a trike.';
      }

      this._cards.forEach((card) => {
        const matches = card.dataset.sizeCard === 'small' ? small : card.dataset.sizeCard === 'standard' && standard;
        card.dataset.match = String(matches);
        const badge = card.querySelector('[data-match-badge]');
        if (badge) badge.hidden = !matches;
      });

      const eyebrow = document.createElement('span');
      eyebrow.className = 'pc-xs__eyebrow';
      eyebrow.textContent = 'Range check';
      const title = document.createElement('h3');
      title.textContent = heading;
      const explanation = document.createElement('p');
      explanation.textContent = body;
      const note = document.createElement('p');
      note.className = 'px-result-note';
      note.textContent = 'This guide checks the published X-seam ranges. It does not confirm overall fit.';

      this._result.dataset.resultState = state;
      this._result.append(eyebrow, title, explanation, note);
    }
  }

  customElements.define('pickens-xseam', PickensXseam);
})();


  } catch(e) { console.error(e); }
})();
})();
